import { TokenPrice, TokenPriceDataByTokenSymbol } from "@cede/types";
import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useQuery } from "@tanstack/react-query";

export const usePrices = () => {
  const apiHelper = useApi();

  const { data, isLoading } = useQuery<TokenPriceDataByTokenSymbol>({
    queryKey: [QueryKeys.PRICES],
    queryFn: async () => {
      const response = await apiHelper.getOrThrow(API_ENDPOINT.PRICES, undefined);
      const tokens = response?.data?.tokens;
      const mappedTokens: TokenPriceDataByTokenSymbol = {};
      tokens?.forEach((token: TokenPrice) => {
        mappedTokens[token.tokenSymbol] = token;
      });
      return mappedTokens;
    },
    enabled: true,
  });

  return { data: data ?? {}, isLoading };
};

export const getPrice = (prices: TokenPriceDataByTokenSymbol, symbol: string, exchangeId?: string) => {
  const tokenPrice = prices[symbol];
  if (!tokenPrice) {
    return 0;
  }
  if (exchangeId && tokenPrice.exchanges[exchangeId] !== undefined && tokenPrice.exchanges[exchangeId] !== null) {
    return tokenPrice.exchanges[exchangeId];
  }
  return tokenPrice.average;
};

export const usePrice = (symbol: string, exchangeId?: string) => {
  const data = usePrices();

  if (data) {
    return getPrice(data.data, symbol, exchangeId);
  }

  return 0;
};
